import type { LessonListItem } from '@/types/apis/Lesson';

import React from 'react';

import DislikeLesson from './DislikeLesson';
import LikeLesson from './LikeLesson';

import useLikeOrDislikeLesson from '@/hooks/queries/useLikeOrDislikeLesson';

type Props = {
  lesson: LessonListItem;
  color?: string;
};

const LessonLikeDislike: React.FC<Props> = ({ lesson, color }) => {
  const { mutateAsync: likeLesson, isPending: isLiking } =
    useLikeOrDislikeLesson({
      lesson_id: lesson.id,
    });

  const { mutateAsync: dislikeLesson, isPending: isDisliking } =
    useLikeOrDislikeLesson({
      lesson_id: lesson.id,
    });

  return (
    <div className="flex gap-5">
      <LikeLesson
        like={lesson.like_count}
        active={lesson.user_liked_content}
        isLoading={isLiking}
        onClick={() => void likeLesson({ action: 'like_action' })}
        disabled={isDisliking}
        color={color}
      />
      <DislikeLesson
        dislike={lesson.dislike_count}
        active={lesson.user_disliked_content}
        isLoading={isDisliking}
        onClick={() => void dislikeLesson({ action: 'dislike_action' })}
        disabled={isLiking}
        color={color}
      />
    </div>
  );
};

export default LessonLikeDislike;
